import { render, staticRenderFns } from "./FalsePositiveIcon.vue?vue&type=template&id=1b6da9d4"
import script from "./FalsePositiveIcon.vue?vue&type=script&lang=js"
export * from "./FalsePositiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports